import React, { ReactElement } from 'react';

import { Card, CardTitle, CardSubtitle, Completion, CompletionText } from './styles';

interface TileProps {
	title: string;
	subtitle: string;
	subtotal?: number;
	total?: number;
}

const Tile = (props: TileProps): ReactElement => {
	return (
		<>
			<Card>
				<CardTitle>{props.title}</CardTitle>
				<CardSubtitle>{props.subtitle}</CardSubtitle>
				<Completion>
					<CompletionText>
						{props.subtotal}/{props.total}
					</CompletionText>
				</Completion>
			</Card>
		</>
	);
};

export default Tile;
